var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.502,
    height: 21.678,
    viewBox: "0 0 21.502 21.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7,26.243A2.243,2.243,0,1,0,9.243,24,2.245,2.245,0,0,0,7,26.243Zm2.99,0a.748.748,0,1,1-.748-.748A.749.749,0,0,1,9.99,26.243Z",
    transform: "translate(-2.515 -6.807)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.485,26.243a2.243,2.243,0,1,0-2.243,2.243A2.245,2.245,0,0,0,23.485,26.243Zm-2.99,0a.748.748,0,1,1,.748.748A.749.749,0,0,1,20.5,26.243Z",
    transform: "translate(-5.545 -6.807)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.317,2.5C3.41,3.378,4.442,13.176,4.6,14.69A2.238,2.238,0,0,0,6.831,16.7H18.48a2.256,2.256,0,0,0,2.193-1.773l1.8-8.379a1.5,1.5,0,0,0-1.463-1.808H5.057L4.734,1.67A.748.748,0,0,0,3.99,1H1.748a.748.748,0,0,0,0,1.5ZM21.006,6.233l-1.795,8.379a.753.753,0,0,1-.732.591H6.831a.746.746,0,0,1-.744-.669l-.874-8.3Z",
    transform: "translate(-1 -1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.db11a0f6.svg";
export { ForwardRef as ReactComponent };